var map = {
	"./Default-Bar-Cover.png": 4537,
	"./fb-icon.svg": 16408,
	"./filters-icon.svg": 21539,
	"./filters.svg": 42250,
	"./ig-icon.svg": 74651,
	"./location-features/big-screen.svg": 32108,
	"./location-features/bring-food.svg": 39332,
	"./location-features/capacity.svg": 31927,
	"./location-features/free-wifi.svg": 33553,
	"./location-features/parking.svg": 16898,
	"./location-features/screen.svg": 40779,
	"./location-features/serves-food.svg": 29299,
	"./location-image.svg": 87710,
	"./parking.svg": 71216,
	"./payment-icon.svg": 47147,
	"./poster-settings-icon.svg": 3898,
	"./settings.svg": 20357,
	"./social-media-icon.svg": 94297,
	"./social-media.svg": 23807,
	"./user-company-icon.svg": 84423,
	"./user-company.svg": 87486,
	"./user-management-icon.svg": 11844,
	"./user-preferences-icon.svg": 83563,
	"./user-preferences.svg": 81883,
	"./user-profile-icon.svg": 41452,
	"./user-profile.svg": 57041,
	"./widget-icon.svg": 59997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68254;